import { render } from "./Claim.vue?vue&type=template&id=093ff804&ts=true"
import script from "./Claim.vue?vue&type=script&lang=ts"
export * from "./Claim.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__